/** @format */

import React from "react";
import "../styles/App.css";
const RateLine = () => {
  return (
    <div className="rates-line">
      <ul>
        <li className="symbol drop" data-symbol="ETH-USD_Binance">
          <span className="dynamics grow" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">ETH/USD</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">-0.23</span>%
          </span>
          (<span className="symbol-price symbol-price-js">1970.64</span>)
        </li>
        <li className="symbol grow" data-symbol="EUR-USD">
          <span className="dynamics grow">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">EUR/USD</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">0.04</span>%
          </span>
          (<span className="symbol-price symbol-price-js">1.06</span>)
        </li>
        <li className="symbol drop" data-symbol="JPM_NYSE">
          <span className="dynamics grow" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">JPM</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">-0.75</span>%
          </span>
          (<span className="symbol-price symbol-price-js">117.37</span>)
        </li>
        <li className="symbol drop" data-symbol="SPX_NYSE">
          <span className="dynamics grow" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">SPX</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">-0.02</span>%
          </span>
          (<span className="symbol-price symbol-price-js">3901.36</span>)
        </li>
        <li className="symbol grow" data-symbol="SPY_NYSE">
          <span className="dynamics grow">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">SPY</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">0.30</span>%
          </span>
          (<span className="symbol-price symbol-price-js">390.62</span>)
        </li>
        <li className="symbol grow" data-symbol="USD-JPY">
          <span className="dynamics grow">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">USD/JPY</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">0.00</span>%
          </span>
          (<span className="symbol-price symbol-price-js">127.85</span>)
        </li>
        <li className="symbol drop" data-symbol="XPT-USD">
          <span className="dynamics grow" style={{ display: "none" }}>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L0 10H14L7 0Z" fill="#2469F0"></path>
            </svg>{" "}
          </span>
          <span className="dynamics drop">
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 10L14 0L8.74228e-07 -1.22392e-06L7 10Z"
                fill="#1D1D1F"></path>
            </svg>{" "}
          </span>
          <span className="symbol-name">XPT/USD</span>
          <span className="symbol-changes">
            <span className="symbol-changes-js">-0.24</span>%
          </span>
          (<span className="symbol-price symbol-price-js">955.60</span>)
        </li>
      </ul>
    </div>
  );
};
export default RateLine;
